// Reusable auto-refresh timer for dashboard-style views.
//
// The component using this mixin must provide a `refreshDashboard()` method
// that re-fetches its data (it may be async), and call `startAutoRefresh()`
// once its first load has finished (usually at the end of mounted()).
//
// Template usage (next to the other heading controls):
//   <a-select v-model="autoRefreshMinutes" style="width: 180px" @change="onAutoRefreshChange">
//     <a-select-option v-for="opt in autoRefreshOptions" :key="opt" :value="opt">
//       Refresh every {{ opt }} min
//     </a-select-option>
//   </a-select>
export default {
  data() {
    return {
      // Default: refresh every 5 minutes
      autoRefreshMinutes: 5,
      autoRefreshOptions: [5, 10, 30],
      autoRefreshTimer: null,
      // True while a refresh is in flight, so slow responses never stack up
      autoRefreshBusy: false
    };
  },
  beforeDestroy() {
    this.stopAutoRefresh();
  },
  methods: {
    // (Re)start the timer using the currently selected minutes
    startAutoRefresh() {
      this.stopAutoRefresh();
      const ms = this.autoRefreshMinutes * 60 * 1000;
      this.autoRefreshTimer = setInterval(this.runAutoRefresh, ms);
    },

    stopAutoRefresh() {
      if (this.autoRefreshTimer) {
        clearInterval(this.autoRefreshTimer);
        this.autoRefreshTimer = null;
      }
    },

    // Called when the user picks a different interval — restart with it
    onAutoRefreshChange() {
      this.startAutoRefresh();
    },

    async runAutoRefresh() {
      if (this.autoRefreshBusy || typeof this.refreshDashboard !== 'function') {
        return;
      }
      this.autoRefreshBusy = true;
      try {
        await this.refreshDashboard();
      } finally {
        this.autoRefreshBusy = false;
      }
    }
  }
};
